import { NotificationsEditorValidationData, NotificationsValue } from '../typings/notificationEditor';

export const OPEN_NOTIFICATIONS_EDITOR = 'OPEN_NOTIFICATIONS_EDITOR';
export type OPEN_NOTIFICATIONS_EDITOR = typeof OPEN_NOTIFICATIONS_EDITOR;

export interface OpenNotificationsEditor {
    type: OPEN_NOTIFICATIONS_EDITOR;
    editorId: string;
    value: NotificationsValue;
}

export function openNotificationsEditor(editorId: string, value: NotificationsValue): OpenNotificationsEditor {
    return {
        type: OPEN_NOTIFICATIONS_EDITOR,
        editorId,
        value
    };
}

export const CLOSE_NOTIFICATIONS_EDITOR = 'CLOSE_NOTIFICATIONS_EDITOR';
export type CLOSE_NOTIFICATIONS_EDITOR = typeof CLOSE_NOTIFICATIONS_EDITOR;

export interface CloseNotificationsEditor {
    type: CLOSE_NOTIFICATIONS_EDITOR;
    editorId: string;
}

export function closeNotificationsEditor(editorId: string): CloseNotificationsEditor {
    return {
        type: CLOSE_NOTIFICATIONS_EDITOR,
        editorId
    };
}

export const CANCEL_NOTIFICATIONS_EDITOR = 'CANCEL_NOTIFICATIONS_EDITOR';
export type CANCEL_NOTIFICATIONS_EDITOR = typeof CANCEL_NOTIFICATIONS_EDITOR;

export interface CancelNotificationsEditor {
    type: CANCEL_NOTIFICATIONS_EDITOR;
    editorId: string;
    value: NotificationsValue;
}

export function cancelNotificationsEditor(editorId: string, value: NotificationsValue): CancelNotificationsEditor {
    return {
        type: CANCEL_NOTIFICATIONS_EDITOR,
        editorId,
        value
    };
}

export const CHANGE_NOTIFICATION_VALUE_FOR_NOTIFICATIONS_EDITOR = 'CHANGE_NOTIFICATION_VALUE_FOR_NOTIFICATIONS_EDITOR';
export type CHANGE_NOTIFICATION_VALUE_FOR_NOTIFICATIONS_EDITOR = typeof CHANGE_NOTIFICATION_VALUE_FOR_NOTIFICATIONS_EDITOR;

export interface ChangeNotificationValueForNotificationsEditor {
    type: CHANGE_NOTIFICATION_VALUE_FOR_NOTIFICATIONS_EDITOR;
    editorId: string;
    index: number;
}

export function changeNotificationValueForNotificationsEditor(
    editorId: string,
    index: number
): ChangeNotificationValueForNotificationsEditor {
    return {
        type: CHANGE_NOTIFICATION_VALUE_FOR_NOTIFICATIONS_EDITOR,
        editorId,
        index
    };
}

export const CHANGE_NOTIFICATION_EMAIL_FOR_NOTIFICATIONS_EDITOR = 'CHANGE_NOTIFICATION_EMAIL_FOR_NOTIFICATIONS_EDITOR';
export type CHANGE_NOTIFICATION_EMAIL_FOR_NOTIFICATIONS_EDITOR = typeof CHANGE_NOTIFICATION_EMAIL_FOR_NOTIFICATIONS_EDITOR;

export interface ChangeNotificationEmailForNotificationsEditor {
    type: CHANGE_NOTIFICATION_EMAIL_FOR_NOTIFICATIONS_EDITOR;
    editorId: string;
    email: string;
}

export function changeNotificationEmailForNotificationsEditor(
    editorId: string,
    email: string
): ChangeNotificationEmailForNotificationsEditor {
    return {
        type: CHANGE_NOTIFICATION_EMAIL_FOR_NOTIFICATIONS_EDITOR,
        editorId,
        email
    };
}

export const VALIDATE_NOTIFICATION_EMAIL_FOR_NOTIFICATIONS_EDITOR =
    'VALIDATE_NOTIFICATION_EMAIL_FOR_NOTIFICATIONS_EDITOR';
export type VALIDATE_NOTIFICATION_EMAIL_FOR_NOTIFICATIONS_EDITOR = typeof VALIDATE_NOTIFICATION_EMAIL_FOR_NOTIFICATIONS_EDITOR;

export interface ValidateNotificationEmailForNotificationsEditor {
    type: VALIDATE_NOTIFICATION_EMAIL_FOR_NOTIFICATIONS_EDITOR;
    editorId: string;
}

export function validateNotificationEmailForNotificationsEditor(
    editorId: string
): ValidateNotificationEmailForNotificationsEditor {
    return {
        type: VALIDATE_NOTIFICATION_EMAIL_FOR_NOTIFICATIONS_EDITOR,
        editorId
    };
}

export const CHANGE_SMS_START_TIME_FOR_NOTIFICATIONS_EDITOR = 'CHANGE_SMS_START_TIME_FOR_NOTIFICATIONS_EDITOR';
export type CHANGE_SMS_START_TIME_FOR_NOTIFICATIONS_EDITOR = typeof CHANGE_SMS_START_TIME_FOR_NOTIFICATIONS_EDITOR;

export interface ChangeSmsStartTimeForNotificationsEditor {
    type: CHANGE_SMS_START_TIME_FOR_NOTIFICATIONS_EDITOR;
    editorId: string;
    startTime: string;
}

export function changeSmsStartTimeForNotificationsEditor(
    editorId: string,
    startTime: string
): ChangeSmsStartTimeForNotificationsEditor {
    return {
        type: CHANGE_SMS_START_TIME_FOR_NOTIFICATIONS_EDITOR,
        editorId,
        startTime
    };
}

export const VALIDATE_SMS_START_TIME_FOR_NOTIFICATIONS_EDITOR = 'VALIDATE_SMS_START_TIME_FOR_NOTIFICATIONS_EDITOR';
export type VALIDATE_SMS_START_TIME_FOR_NOTIFICATIONS_EDITOR = typeof VALIDATE_SMS_START_TIME_FOR_NOTIFICATIONS_EDITOR;

export interface ValidateSmsStartTimeForNotificationsEditor {
    type: VALIDATE_SMS_START_TIME_FOR_NOTIFICATIONS_EDITOR;
    editorId: string;
}

export function validateSmsStartTimeForNotificationsEditor(
    editorId: string
): ValidateSmsStartTimeForNotificationsEditor {
    return {
        type: VALIDATE_SMS_START_TIME_FOR_NOTIFICATIONS_EDITOR,
        editorId
    };
}

export const CHANGE_SMS_END_TIME_FOR_NOTIFICATIONS_EDITOR = 'CHANGE_SMS_END_TIME_FOR_NOTIFICATIONS_EDITOR';
export type CHANGE_SMS_END_TIME_FOR_NOTIFICATIONS_EDITOR = typeof CHANGE_SMS_END_TIME_FOR_NOTIFICATIONS_EDITOR;

export interface ChangeSmsEndTimeForNotificationsEditor {
    type: CHANGE_SMS_END_TIME_FOR_NOTIFICATIONS_EDITOR;
    editorId: string;
    endTime: string;
}

export function changeSmsEndTimeForNotificationsEditor(
    editorId: string,
    endTime: string
): ChangeSmsEndTimeForNotificationsEditor {
    return {
        type: CHANGE_SMS_END_TIME_FOR_NOTIFICATIONS_EDITOR,
        editorId,
        endTime
    };
}

export const VALIDATE_SMS_END_TIME_FOR_NOTIFICATIONS_EDITOR = 'VALIDATE_SMS_END_TIME_FOR_NOTIFICATIONS_EDITOR';
export type VALIDATE_SMS_END_TIME_FOR_NOTIFICATIONS_EDITOR = typeof VALIDATE_SMS_END_TIME_FOR_NOTIFICATIONS_EDITOR;

export interface ValidateSmsEndTimeForNotificationsEditor {
    type: VALIDATE_SMS_END_TIME_FOR_NOTIFICATIONS_EDITOR;
    editorId: string;
}

export function validateSmsEndTimeForNotificationsEditor(editorId: string): ValidateSmsEndTimeForNotificationsEditor {
    return {
        type: VALIDATE_SMS_END_TIME_FOR_NOTIFICATIONS_EDITOR,
        editorId
    };
}

export const CHANGE_INTERVAL_NOTIFICATION_FOR_NOTIFICATIONS_EDITOR =
    'CHANGE_INTERVAL_NOTIFICATION_FOR_NOTIFICATIONS_EDITOR';
export type CHANGE_INTERVAL_NOTIFICATION_FOR_NOTIFICATIONS_EDITOR = typeof CHANGE_INTERVAL_NOTIFICATION_FOR_NOTIFICATIONS_EDITOR;

export interface ChangeIntervalNotificationForNotificationsEditor {
    type: CHANGE_INTERVAL_NOTIFICATION_FOR_NOTIFICATIONS_EDITOR;
    editorId: string;
    index: number;
    interval: string;
}

export function changeIntervalNotificationForNotificationsEditor(
    editorId: string,
    index: number,
    interval: string
): ChangeIntervalNotificationForNotificationsEditor {
    return {
        type: CHANGE_INTERVAL_NOTIFICATION_FOR_NOTIFICATIONS_EDITOR,
        editorId,
        index,
        interval
    };
}

export const CHANGE_PERCENT_NOTIFICATION_FOR_NOTIFICATIONS_EDITOR =
    'CHANGE_PERCENT_NOTIFICATION_FOR_NOTIFICATIONS_EDITOR';
export type CHANGE_PERCENT_NOTIFICATION_FOR_NOTIFICATIONS_EDITOR = typeof CHANGE_PERCENT_NOTIFICATION_FOR_NOTIFICATIONS_EDITOR;

export interface ChangePercentNotificationForNotificationsEditor {
    type: CHANGE_PERCENT_NOTIFICATION_FOR_NOTIFICATIONS_EDITOR;
    editorId: string;
    index: number;
    percent?: string;
}

export function changePercentNotificationForNotificationsEditor(
    editorId: string,
    index: number,
    percent?: string
): ChangePercentNotificationForNotificationsEditor {
    return {
        type: CHANGE_PERCENT_NOTIFICATION_FOR_NOTIFICATIONS_EDITOR,
        editorId,
        index,
        percent
    };
}

export const CHANGE_NOTIFICATION_DISABLE_VALUE_FOR_NOTIFICATIONS_EDITOR =
    'CHANGE_NOTIFICATION_DISABLE_VALUE_FOR_NOTIFICATIONS_EDITOR';
export type CHANGE_NOTIFICATION_DISABLE_VALUE_FOR_NOTIFICATIONS_EDITOR = typeof CHANGE_NOTIFICATION_DISABLE_VALUE_FOR_NOTIFICATIONS_EDITOR;

export interface ChangeNotificationDisableValueForNotificationsEditor {
    type: CHANGE_NOTIFICATION_DISABLE_VALUE_FOR_NOTIFICATIONS_EDITOR;
    editorId: string;
    index: number;
    value: boolean;
}

export function changeNotificationDisableValueForNotificationsEditor(
    editorId: string,
    index: number,
    value: boolean
): ChangeNotificationDisableValueForNotificationsEditor {
    return {
        type: CHANGE_NOTIFICATION_DISABLE_VALUE_FOR_NOTIFICATIONS_EDITOR,
        editorId,
        index,
        value
    };
}

export const UPDATE_NOTIFICATIONS_EDITOR_VALIDATION_DATA = 'UPDATE_NOTIFICATIONS_EDITOR_VALIDATION_DATA';
export type UPDATE_NOTIFICATIONS_EDITOR_VALIDATION_DATA = typeof UPDATE_NOTIFICATIONS_EDITOR_VALIDATION_DATA;

export interface UpdateNotificationsEditorValidationData {
    type: UPDATE_NOTIFICATIONS_EDITOR_VALIDATION_DATA;
    editorId: string;
    validationData: NotificationsEditorValidationData;
}

export function updateNotificationsEditorValidationData(
    editorId: string,
    validationData: NotificationsEditorValidationData
): UpdateNotificationsEditorValidationData {
    return {
        type: UPDATE_NOTIFICATIONS_EDITOR_VALIDATION_DATA,
        editorId,
        validationData
    };
}

export const CHANGE_PHONE_FOR_NOTIFICATIONS_EDITOR = 'CHANGE_PHONE_FOR_NOTIFICATIONS_EDITOR';
export type CHANGE_PHONE_FOR_NOTIFICATIONS_EDITOR = typeof CHANGE_PHONE_FOR_NOTIFICATIONS_EDITOR;

export interface ChangePhoneForNotificationsEditor {
    type: CHANGE_PHONE_FOR_NOTIFICATIONS_EDITOR;
    editorId: string;
}

export function changePhoneForNotificationsEditor(editorId: string): ChangePhoneForNotificationsEditor {
    return {
        type: CHANGE_PHONE_FOR_NOTIFICATIONS_EDITOR,
        editorId
    };
}

export type NotificationEditorAction =
    | OpenNotificationsEditor
    | CloseNotificationsEditor
    | CancelNotificationsEditor
    | ChangeNotificationValueForNotificationsEditor
    | ChangeNotificationEmailForNotificationsEditor
    | ValidateNotificationEmailForNotificationsEditor
    | ChangeSmsStartTimeForNotificationsEditor
    | ChangeSmsEndTimeForNotificationsEditor
    | ChangeIntervalNotificationForNotificationsEditor
    | ChangePercentNotificationForNotificationsEditor
    | ValidateSmsStartTimeForNotificationsEditor
    | ValidateSmsEndTimeForNotificationsEditor
    | UpdateNotificationsEditorValidationData
    | ChangeNotificationDisableValueForNotificationsEditor
    | ChangePhoneForNotificationsEditor;
